import {
    ADD_PREFERENCES,
    ManualAccommodationChainActionTypes,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_CHAIN,
    RESET_FILTERS,
    RESIZE_COLUMN,
    SET_CHAIN,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_ORDER_BY,
    SET_PAGE,
    SET_POST_FINISHED,
    SET_PREFERENCES as SET_CHAIN_PREFERENCES,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_EDIT,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_NAME,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_NAME,
    SET_COLUMNS
} from './actionTypes';
// Types
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { ManualAccommodationChainState } from '../objects/manualAccommodationChainState';
import { DEFAULT_MANUAL_ACCOMMODATION_CHAIN_COLUMNS, setManualAccommodationChainPreference } from '../utils/setManualAccommodationChainPreference';
import { applyColumnResize } from '../../utils/list/utils/columnResize';

const initialState: ManualAccommodationChainState = {
    chain: null,
    columns: DEFAULT_MANUAL_ACCOMMODATION_CHAIN_COLUMNS,
    count: 0,
    create: false,
    edit: false,
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_name: '',
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    limit: 50,
    list: null,
    name: '',
    name_error: '',
    order: 'asc',
    order_by: 'name',
    page: 0,
    preferences: [],
    refresh: false,
    running: false,
    search: ''
};

export default (state: ManualAccommodationChainState = initialState, action: ManualAccommodationChainActionTypes | ProfileActionTypes): ManualAccommodationChainState => {
    switch (action.type) {
        case ADD_PREFERENCES: {
            return { ...state, preferences: [...state.preferences, ...action.payload] };
        }
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload + 1] };
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload - 1] };
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case RESET_CHAIN: {
            return { ...state, create: false, name: '', name_error: '' };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_name: '',
                filter_period: 'CREATION',
                filter_period_type: 0
            };
        }
        case SET_CHAIN: {
            return { ...state, chain: action.payload, edit: false, name: action.payload.name, name_error: '' };
        }
        case SET_ERRORS: {
            const errors = action.payload;
            const new_state: ManualAccommodationChainState = { ...state };
            errors.map(error => {
                new_state[error.key] = error.error;
            });
            return { ...new_state };
        }
        case SET_EXPORT_TYPE: {
            return { ...state, export_type: action.payload };
        }
        case SET_LIMIT: {
            return { ...state, list: null, limit: action.payload };
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return { ...state, count: count, list: results, running: false };
        }
        case SET_ORDER_BY: {
            return { ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return { ...state, list: null, page: action.payload };
        }
        case SET_POST_FINISHED: {
            return {
                ...state,
                chain: null,
                create: false,
                name: '',
                name_error: '',
                refresh: !state.refresh
            };
        }
        case SET_PREFERENCES: {
            const { columns, preferences, order_by, order } = setManualAccommodationChainPreference(action.payload, state.columns);
            return { ...state, columns, preferences, order_by, order };
        }
        case SET_CHAIN_PREFERENCES: {
            return { ...state, preferences: action.payload };
        }
        case RESIZE_COLUMN: {
            return { ...state, columns: applyColumnResize(state.columns, action.payload) };
        }
        case SET_RUNNING: {
            return { ...state, running: action.payload };
        }
        case SET_SEARCH: {
            return { ...state, list: null, page: 0, search: action.payload };
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = { ...columns[action.payload] };
            column.checked = !column.checked;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case TOGGLE_CREATE: {
            return { ...state, create: !state.create };
        }
        case TOGGLE_EDIT: {
            return { ...state, edit: !state.edit, name: state.chain !== null ? state.chain.name : '', name_error: '' };
        }
        case TOGGLE_EXPORT: {
            return { ...state, export_list: action.payload };
        }
        case TOGGLE_EXPORT_FULL: {
            return { ...state, export_full: !state.export_full };
        }
        case TOGGLE_FILTERS: {
            return { ...state, filter_open: !state.filter_open };
        }
        case TOGGLE_REFRESH: {
            return { ...state, refresh: !state.refresh };
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return { ...state, filter_created_date_gte: action.payload };
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return { ...state, filter_created_date_lte: action.payload };
        }
        case UPDATE_FILTER_CREATOR: {
            return { ...state, filter_creator: action.payload };
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return { ...state, filter_last_author: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return { ...state, filter_modified_date_gte: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return { ...state, filter_modified_date_lte: action.payload };
        }
        case UPDATE_FILTER_NAME: {
            return { ...state, filter_name: action.payload };
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return { ...state, filter_period_type: action.payload };
        }
        case UPDATE_NAME: {
            return { ...state, name: action.payload };
        }
        case SET_COLUMNS: {
            return { ...state, columns: action.payload };
        }
        default:
            return state;
    }
};